import { t } from 'i18next'
import React, { useEffect } from 'react'

import { fetchGroups } from '../../../functions/dataHelpers'
import {
  useCardsStore,
  useFeedbackStore,
  useStore,
  useTableGroupsStore,
} from '../../../functions/store'

interface GroupSelectProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  className?: string
}

const GroupSelect: React.FC<GroupSelectProps> = (props) => {
  const userStore = useStore()
  const { groups, setGroups } = useTableGroupsStore((state) => state)
  const feedbackStore = useFeedbackStore((state) => state)
  const cardsStore = useCardsStore((state) => state)

  useEffect(() => {
    const loadGroups = async () => {
      const groups = await fetchGroups()
      setGroups(groups)
    }
    loadGroups()
  }, [])

  if (!groups || groups.length === 0) {
    return null
  }

  return (
    <div
      {...props}
      className={`w-full ms-auto lg:w-64 flex-shrink-0 ${
        props.className || ''
      }`}
    >
      <select
        className="block w-full px-4 py-3 bg-slate-800/80 border border-slate-600/50 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500/50 focus:border-red-500/50 text-sm transition-all"
        value={userStore.group?._id || ''}
        onChange={async (e) => {
          const selectedGroup = groups.find(
            (group) => group._id === e.currentTarget.value,
          )
          if (selectedGroup) {
            userStore.setUser({
              ...userStore,
              group: selectedGroup,
            })
            feedbackStore.feedbackActions.reset()
            cardsStore.cardsActions.reset()
          }
        }}
      >
        <option value="" disabled>
          {t('table.selectOption')}
        </option>
        {groups.map((group) => (
          <option key={group._id} value={group._id}>
            {group?.group}
          </option>
        ))}
      </select>
    </div>
  )
}

export default GroupSelect
